import { createContext } from "react";

export const FavoriteGroupsContext = createContext();
